import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Dropdown, MenuProps, notification } from 'antd';
import { getNavbarMenuItemIcon, getRapportageColor } from 'helpers/menu-helpers';
import { MenuItem } from 'pages/home/models/types/home';
import { FC, useState } from 'react';
import { useNavigate } from 'react-router';
import styles from './main-menu.module.scss';
import { getMenuItemChild } from './menu-item-child';

interface MenuItemRapportageProps {
  menuItem: MenuItem;
}
export const MenuItemRapportage: FC<MenuItemRapportageProps> = ({ menuItem }) => {
  const [isVisible, setVisible] = useState<boolean>(false);
  const nav = useNavigate();
  const isDisabled = menuItem.childMenuItems.find(f => f.isGereed) === undefined;
  const items: MenuProps['items'] = [...menuItem.childMenuItems.map(item => getMenuItemChild(item, nav, () => setVisible(false), true))];
  return (
    <div
      onClick={() => {
        if (isDisabled) {
          notification.info({ message: 'Uw KringloopWijzer is nog niet compleet; u kunt dan nog geen rapportage aanvragen.' });
        }
      }}
      className={isVisible ? styles.active : styles.hover}>
      <Dropdown
        disabled={isDisabled}
        onOpenChange={visible => {
          setVisible(visible);
        }}
        menu={{ items }}>
        <span className={styles.flexButton}>
          <span className={styles.title} style={{ color: getRapportageColor({ isDisabled, isGereed: menuItem.isGereed }) }}>
            {menuItem.titel}
          </span>
          <FontAwesomeIcon
            className={styles.icon}
            style={{ color: getRapportageColor({ isDisabled, isGereed: menuItem.isGereed }) }}
            icon={getNavbarMenuItemIcon(menuItem)}
          />
        </span>
      </Dropdown>
    </div>
  );
};
